<template>
  <div class="row">
    <div class="col-12">
      <div class="subpage">
        <h1 class="subpage__headline">
          Kontakt
        </h1>
        <div class="subpage__content">
       
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contact",
   title () {
    return `Kontakt`
  },
 
  pageType: 'Kontaktowa',
  data() {
    return {
      title: "Contact page",
    };
  },
  
};
</script>
